import * as microsoftTeams from "@microsoft/teams-js";
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import * as msal from "@azure/msal-browser";

export class HttpService {
  // storageService = StorageService.getService();

  instance = axios.create();
  accessToken = null;

  // Request interceptor
  requestInterceptor = this.instance.interceptors.request.use(
    (config) => {
      //Local usage

      // config.headers["Authorization"] = "Bearer " + '';
      // return config;

      //Stage usage
      let authmech =
        sessionStorage.getItem("authMech") != undefined
          ? sessionStorage.getItem("authMech")
          : "SSO";
      if (authmech === "Forced") {
        return GetToken().then((response) => {
          if (response) {
            let token = response.accessToken;
            console.log(response);
            if (token) {
              config.headers["Authorization"] = "Bearer " + token;
            }
          }
          return config;
        });
      } else if (authmech === "SSO") {
        return GetSSOToken()
          .then((response: any) => {
            let token = response;
            // let token = sessionStorage.getItem("tempToken");
            //console.log(response);
            if (token) {
              config.headers["Authorization"] = "Bearer " + token;
            }
            return config;
          })
          .catch((err: any) => {
            console.log(err);
            return config;
          });
      } else return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  // Add a response interceptor
  responseInterceptor = this.instance.interceptors.response.use(
    (response) => {
      return response.data;
    },
    function (error) {
      const originalRequest = error.config;
      // All error code handlings here
      if (error.response.status === 401 && !originalRequest._retry) {
        console.log("ERROR ", error.response);
      }

      // return Error object with Promise
      return Promise.reject(error);
    }
  );

  get = (getUrl: string) => {
    console.log("getUrl ", getUrl);
    return this.instance.get(getUrl).catch(function (error: any) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
    });
  };

  post = (postURL: string, data: any) => {
    return this.instance.post(postURL, data).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response);
        console.log(error.response.status);
        console.log(error.response.headers);
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
    });
  };
}

export const msalConfig: msal.Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID as string,
    authority: import.meta.env.VITE_AAD_APP_OAUTH_AUTHORITY as string,
    redirectUri: import.meta.env.VITE_TAB_ENDPOINT as string, // This should be in the list of redirect uris for the AAD app
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function GetToken() {
  var request = {
    scopes: [import.meta.env.VITE_API_SCOPE as string],
    account: msalInstance.getAllAccounts()[0],
  };
  return await msalInstance.acquireTokenSilent(request).catch((error) => {
    console.log(error);
    console.log("silent token acquisition fails. acquiring token using popup");

    // fallback to interaction when silent call fails
    return msalInstance
      .acquireTokenPopup(request)
      .then((tokenResponse) => {
        return tokenResponse;
      })
      .catch((error) => {
        console.log(error);
      });
  });
}

export async function GetSSOToken() {
  let loginPromise = new Promise((resolve, reject) => {
    microsoftTeams.authentication
      .getAuthToken()
      .then((token: string) => {
        if (token) {
          resolve(token);
        } else {
          reject("No Auth");
        }
      })
      .catch((err: any) => {
        reject(err);
      });
  });
  //}
  return loginPromise;
}
